module.exports = __webpack_public_path__ + "img/chevron-down.f5f613ba.svg";